import {
  BpkLargeSpinner,
  SPINNER_TYPES,
} from '@skyscanner-internal/backpack-web/bpk-component-spinner';

import STYLES from './MapLoadingFallback.module.scss';

export const MapLoadingFallback = () => (
  <div className={STYLES.container}>
    <BpkLargeSpinner type={SPINNER_TYPES.primary} aria-label="Loading map" />
  </div>
);
